import { Grid, Layout } from '@design-systems/canvas-ui'
import { useAnalytics } from '@praxis/analytics/client'
import { useAuth } from '@praxis/component-auth'
import { useEnv } from '@praxis/component-runtime-env'
import _ from 'lodash'
import { SpinnerComponent } from 'mvscommoncomponents'
import { useEffect } from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { appContants, config } from '../App'
import { createFireflyEvent } from '../common/helper'
import MainRouter from '../globalComponents/MainRouter'
import rootReducer from '../store'
import configureStore from '../store/store'
import { requestInterceptor } from '../utils/httpUtils'

const remoteAppScope = 'lcm'
export const userInfoData = {}

export const Main = (props) => {
  const auth = useAuth()
  const env = useEnv()
  const { logout } = auth
  const { store, persistor } = configureStore()
  const { sendEvent } = useAnalytics()

  useEffect(() => {
    if (props.store) {
      props.store.reducerManager.add(remoteAppScope, rootReducer)
    }
  }, [props.store])

  if (auth.session) {
    let userInfo = auth.session.userInfo
    _.set(config, 'headers.User-Name', userInfo.fullName)
    _.set(config, 'headers.User-Email', userInfo.email)
    _.set(config, 'headers.User-Id', userInfo.lanId)
    requestInterceptor(auth.session)
    _.set(
      appContants,
      'rfiFileUploadConstants',
      env?.mfelcm?.rfiFileUploadConstants,
    )
  }

  const sendDataToFirefly = () => {
    if (props.userInfoData && props.userInfoData?.id) {
      sendEvent(
        createFireflyEvent('selected_mfe', 'LCM MFE', props.userInfoData),
      )
    }
  }

  useEffect(() => {
    if (props.userInfoData) {
      Object.assign(userInfoData, { ...props.userInfoData })
    }
    sendDataToFirefly() // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.userInfoData])

  useEffect(() => {
    let checkUserAuthStatus = () => {
      let session = auth.session
      if (props.isExternalDomain && session) {
        // We're on a POL site of some kind
        const SSOSESSIONINFOCookie = getCookieValue('SSOSESSIONINFO')

        if (SSOSESSIONINFOCookie) {
          const SSOSESSIONINFOcoded = window.atob(SSOSESSIONINFOCookie)
          const SSOSESSIONINFOJson = JSON.parse(SSOSESSIONINFOcoded)
          if (
            !SSOSESSIONINFOJson.user ||
            !SSOSESSIONINFOJson.login_status ||
            String(session.userInfo.lanId) !== String(SSOSESSIONINFOJson.user)
          ) {
            forceSignOut()
          }
        }
      }
    }
    checkUserAuthStatus()
  }, [auth.session]) // eslint-disable-line react-hooks/exhaustive-deps

  let getCookieValue = (cookieName) => {
    return (
      document.cookie
        .split('; ')
        .find((row) => row.startsWith(cookieName + '='))
        ?.split('=')[1] ?? null
    )
  }

  let forceSignOut = () => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('environment')
    localStorage.removeItem('id_token')
    logout()
  }

  // important
  // The container passes its Redux store when LCM is embedded.
  // Use this to avoid rendering a second Canvas Layout inside the container.
  const isEmbedded = Boolean(props.store)

  const content = (
    <Grid.Container spacing="none" data-testid="mainAuthenticatedLayout">
      <Grid.Item size={{ xs: 12 }}>
        <MainRouter />
      </Grid.Item>
    </Grid.Container>
  )

  return (
    <Provider store={store}>
      <PersistGate loading={<SpinnerComponent />} persistor={persistor}>
        {isEmbedded ? (
          content
        ) : (
          // Standalone LCM still needs Layout for the Canvas shell/portal behavior.
          <Layout className="C-Layout C-Mode--light" fullWidth darkMode={false}>
            <Layout.Body includeRail className="hc8-pa-none">
              {content}
            </Layout.Body>
          </Layout>
        )}
      </PersistGate>
    </Provider>
  )
}
